import * as React from 'react';

import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import TuneIcon from '@mui/icons-material/Tune';
import ReportTypeSelector from 'components/ReportRequestV2/ReportTypeSelector';

import { StepProps } from './types';
import { REPORT_KINDS } from '../model/constants';

const ICONS = {
  market_survey: <AssessmentOutlinedIcon />,
  optimization: <TuneIcon />,
  mix_and_match: <ShuffleIcon />,
};

const OPTIONS = REPORT_KINDS.map((k) => ({
  value: k.kind,
  title: k.title,
  description: k.description,
  icon: ICONS[k.kind],
}));

const TypeStep: React.FC<StepProps> = ({ state, dispatch, errors }) => (
  <ReportTypeSelector
    label="What kind of report do you need?"
    options={OPTIONS}
    value={state.reportKind === 'update_products' ? null : state.reportKind}
    onChange={(kind) => dispatch({ type: 'selectReportKind', kind })}
    error={errors.reportKind}
  />
);

export default TypeStep;
